/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { currencyFormat, idNamingConversion } from "../../../../../helpers/utilities";
import { PrimaryDrawer } from "../../Drawer/PrimaryDrawer";
import ReportModal from "../../ReportModal";
import { AutoCompleteComponent } from "../../AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, Box } from "@mui/material";
import DateIcon from "../../Icons/Date";
import clsx from "clsx";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import productActions from "../../../../Product/Setup/redux/actions";
import { getRequest } from '../../../../../helpers/axiosClient';
import { Space, Col, Row } from 'antd';
import moment from 'moment';

export const ProductGroupAnalysis = (props) => {
    const { visible, onProductAnalysisVisible, title } = props;
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [groupId, setGroupId] = useState('');
    const [toDate, setToDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [customerData, setcustomerData] = useState([]);
    const [reportOpen, setReportOpen] = useState(false);

    useEffect(() => {
        if (visible) {
            dispatch({
                type: productActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
        }
    }, [visible])

    const dispatch = useDispatch();

    const handleClose = () => {
        onProductAnalysisVisible(false);
        setLoading(false);
        setGroupId('');
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length > 0) {
            return a[0];
        }
        return [];
    }

    const productGroupSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            let url = groupId ? `GROUP/0/${groupId}` : `All/0/0`;
            url += `?toDate=${moment(toDate).format("YYYY-MM-DD")}`;
            let response = getRequest(`${process.env.REACT_APP_API_URL}/productWiseReport/${url}`);
            response.then(payload => {
                // Handle the fetched data here
                let data = payload.data;
                if (data && Object.keys(data).length > 0) {
                    let a = [];
                    Object?.entries(data)?.map(([key, value]) => {
                        return value.map((v) => { return a.push(v) })
                    });
                    setcustomerData(a);
                } else {
                    setcustomerData([]);
                }
                setReportOpen(true);
                setLoading(false);
            }).catch(error => {
                // Handle any errors
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
    const classes = customStyles();
    return (
        <>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={title}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => productGroupSubmit(e)}>
                        <div className={classes.customFormFlex}>
                            <AutoCompleteComponent
                                name={"All Products Group"}
                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                details={productGroupDetails}
                                parentValue={customObject(productGroupDetails, groupId)}
                                position={"bottom"}
                                customClasses={classes.customFilterNone}
                                id={idNamingConversion('All Products Group', 'stockTransaction', 'DropDown')}
                                onChangeText={(data) => {
                                    if (data === '') {
                                        setGroupId('')
                                    }
                                }}
                                onChange={(data) => setGroupId(data?.id)}
                            />
                            {/* <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={fromDate}
                                        format='dd/MM/yyyy'
                                        label="From Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('From Date', 'productAnalysis', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ? setFromDate(new Date()) : setFromDate(newValue)
                                        }}
                                    />
                                </LocalizationProvider>
                            </div> */}
                            <div className={clsx(classes.margin30t, classes.dateAdjust)}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DesktopDatePicker
                                        fullWidth
                                        slots={{
                                            openPickerIcon: DateIcon
                                        }}
                                        views={['year', 'month', 'day']}
                                        value={toDate}
                                        format='dd/MM/yyyy'
                                        label="Date"
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        slotProps={{
                                            textField: {
                                                id: idNamingConversion('To Date', 'productAnalysis', 'TextField'),
                                                autoComplete: 'one-time-code'
                                            },
                                        }}
                                        // readOnly={true}
                                        onChange={(newValue) => {
                                            (newValue === null || newValue === 'Invalid Date') ? setToDate(new Date()) : setToDate(newValue)
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center">
                                <Button
                                    key="save"
                                    type="submit"
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: loading })}>OK</Button>
                                <Button
                                    key="cancel"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleClose()}
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: loading })}>Cancel</Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <ReportModal
                title={title}
                open={reportOpen}
                list={
                    <>
                        <div className={clsx(classes.downloadsReportHeading, classes.textAlignCenter)}>
                            <h4 className={classes.aTitle}>{customObject(productGroupDetails, groupId)?.name || 'All Products'}</h4>
                        </div>
                        <Row className={clsx(classes.bill, classes.billReportHead, classes.margin20t, classes.viewPrint, 'no-break')}>
                            <Col span={3}><h6>Product Name</h6></Col>
                            <Col span={2}><h6>Product ID</h6></Col>
                            <Col span={2}><h6>Sold Unit</h6></Col>
                            <Col span={2}><h6>Sold Qty.</h6></Col>
                            <Col span={2}><h6>Sold Amnt.</h6></Col>
                            <Col span={2}><h6>Purch. Unit</h6></Col>
                            <Col span={2}><h6>Purch. Qty.</h6></Col>
                            <Col span={3}><h6>Purch. Amnt.</h6></Col>
                            <Col span={2}><h6>Bal. Qty.</h6></Col>
                            <Col span={2}><h6>Avg. Price.</h6></Col>
                            <Col span={2}><h6>Stock Value</h6></Col>
                        </Row>
                        {
                            customerData?.length > 0 ? customerData.map((data, i) => (
                                <Row key={i} className={clsx(classes.bill, 'no-break')}>
                                    <Col span={3}><p>{data?.product || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.productId || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.soldUnit || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.soldQuantity || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.soldAmount ? `₹ ${currencyFormat(data?.soldAmount || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.purchaseUnit || '---'}</p></Col>
                                    <Col span={2}><p style={{ padding: "0 5px" }}>{data?.purchaseQuantity || '---'}</p></Col>
                                    <Col span={3}><p style={{ padding: "0 5px" }} >{data?.purchaseAmount ? `₹ ${currencyFormat(data?.purchaseAmount || 0)}` : '---'}</p></Col>
                                    <Col span={2}><p>{((data?.purchaseQuantity || 0) - (data?.soldQuantity || 0))}</p></Col>
                                    <Col span={2}><p>{data?.purchaseAmount && data?.purchaseQuantity ? `₹ ${currencyFormat(data?.purchaseAmount / data?.purchaseQuantity)}` : '---'}</p></Col>
                                    <Col span={2}><p>{data?.purchaseAmount && data?.purchaseQuantity ? `₹ ${currencyFormat(((data?.purchaseQuantity || 0) - (data?.soldQuantity || 0)) * (data?.purchaseAmount / data?.purchaseQuantity))}` : '---'}</p></Col>
                                </Row>
                            )) : <Row className={clsx(classes.bill)}><Col span={24}>
                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>Sorry, we couldn’t find any data for the selected criteria. Please refine your filter</p>
                            </Col></Row>
                        }

                        {
                            customerData?.length > 0 &&
                            <Row className={clsx(classes.bill, 'no-break')}>
                                <Col span={7}><h6 style={{ backgroundColor: "#fff", color: "#000", fontWeight: "500", fontSize: 18 }}>Total:</h6></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}>{customerData.reduce((sum, el) => sum + (parseFloat(el.soldQuantity) || 0), 0)}</p></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}>{`₹ ${currencyFormat(customerData.reduce((sum, el) => sum + (parseFloat(el?.soldAmount) || 0), 0))}`}</p></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}></p></Col>
                                <Col span={2}><p style={{ padding: "0 5px" }}>{customerData.reduce((sum, el) => sum + (parseFloat(el.purchaseQuantity) || 0), 0)}</p></Col>
                                <Col span={3}><p style={{ padding: "0 5px" }} >{`₹ ${currencyFormat(customerData.reduce((sum, el) => sum + (parseFloat(el?.purchaseAmount) || 0), 0))}`}</p></Col>
                                <Col span={2}><p>{customerData.reduce((sum, el) => sum + (parseFloat(el.purchaseQuantity) || 0), 0) - customerData.reduce((sum, el) => sum + (parseFloat(el.soldQuantity) || 0), 0)}</p></Col>
                                <Col span={2}><p>
                                    {(() => {
                                        const totalAvgSum = customerData.reduce((sum, el) => {
                                            const quantity = parseFloat(el?.purchaseQuantity) || 0;
                                            const amount = parseFloat(el?.purchaseAmount) || 0;
                                            const rowAvg = quantity > 0 ? amount / quantity : 0;
                                            return sum + rowAvg;
                                        }, 0);

                                        return `₹ ${currencyFormat(totalAvgSum)}`;
                                    })()}
                                </p></Col>
                                <Col span={2}><p>
                                    {(() => {
                                        const total = customerData.reduce((sum, el) => {
                                            const purchaseQty = parseFloat(el?.purchaseQuantity) || 0;
                                            const soldQty = parseFloat(el?.soldQuantity) || 0;
                                            const purchaseAmt = parseFloat(el?.purchaseAmount) || 0;

                                            const remainingQty = purchaseQty - soldQty;
                                            const avgPrice = purchaseQty > 0 ? purchaseAmt / purchaseQty : 0;

                                            const rowValue = remainingQty * avgPrice;

                                            return sum + rowValue;
                                        }, 0);

                                        return `₹ ${currencyFormat(total)}`;
                                    })()}
                                </p></Col>
                            </Row>
                        }
                    </>
                }
                reportType={'landscape'}
                businessDetails={businessDetails}
                handleClose={() => { setReportOpen(false); handleClose(); }}
            />
        </>
    )
}